export default __webpack_public_path__ + "9f198b963f854e5442c82372af9a7db2.png";